import React from 'react';
import { Tabs, Tab, useMediaQuery, useTheme } from '@mui/material';

function ResponsiveTabs({ tabValue, handleChange }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Centers only on mobile resolutions

  return (
    <Tabs
      value={tabValue}
      onChange={handleChange}
      textColor="secondary"
      indicatorColor="secondary"
      centered={isMobile} // Centered only on mobile resolutions
      sx={{
        '& .MuiTabs-indicator': { backgroundColor: 'rgba(244,205,24,1)' },
      }}
    >
      <Tab
        label="THCA"
        sx={{
          color: '#fff', // Default color for unselected tabs
          fontFamily: 'Montserrat, Arial, sans-serif',
          '&.Mui-selected': { color: 'rgba(244,205,24,1)' }, // Selected tab color
        }}
      />
      <Tab
        label="CBD"
        sx={{
          color: '#fff',
          fontFamily: 'Montserrat, Arial, sans-serif',
          '&.Mui-selected': { color: 'rgba(244,205,24,1)' },
        }}
      />
    </Tabs>
  );
}

export default ResponsiveTabs;
